// -----------------  FETCH CONFIGURATION -----------------
export const FETCH_CONFIGURATION_LOADING = 'FETCH_CONFIGURATION_LOADING';
export const FETCH_CONFIGURATION_SUCCESS = 'FETCH_CONFIGURATION_SUCCESS';
export const FETCH_CONFIGURATION_ERROR = 'FETCH_CONFIGURATION_ERROR';
